import { FileRecord } from './FileRecord';

export const IncidentTypes = [
    'issue',
    'almost-accident',
    'work-injury',
    'whistleblower'
] as const;
export type IncidentType = typeof IncidentTypes[number];

export const IncidentStatusTypes = ['new', 'in-progress', 'resolved'] as const;
export type IncidentStatus = typeof IncidentStatusTypes[number];

export const IncidentPriorityTypes = ['0 - unassigned', '1 - low', '2 - normal', '3 - high', '4 - urgent'] as const;
export type IncidentPriority = typeof IncidentPriorityTypes[number];

export type IncidentView = IncidentBase & {
    email:string,
    history: IncidentHistoryEntry[]
    messages: IncidentMessage[]
    images: FileRecord[]
}

export type IncidentBase = {
    id:string,
    name:string, // Name will never be saved when anonymous, so no need for encryption
    type: IncidentType,
    title:string,
    description:string,
    solutionDescription:string,
    anonymousSelected:boolean,
    notificationsSelected:boolean,
    status:IncidentStatus,
    priority:IncidentPriority,
    created:Date,
    hidden:boolean
};


export type IncidentListing = {
    id:string,
    type: IncidentType,
    title:string,
    anonymousSelected:boolean,
    notificationsSelected:boolean,
    status:IncidentStatus,
    priority:IncidentPriority,
    created:Date,
    hidden:boolean
};

export type IncidentHistoryEntry = 
{
    userId:string,
    userName:string,
    timestamp:Date,
}
& (
    { type:'CreatedIncident' } |
    { type:'UpdatedIncident', status:IncidentStatus, priority:IncidentPriority } |
    { type:'SentMessageToIncidentReporter' } |
    { type:'SentMessageToIncidentResponders' } |
    { type:'Unknown', eventName:string }
);

export type IncidentMessage = {
    id:string,
    incidentId:string,
    sender : 
        { type:'reporter' } |
        { type:'responder', userId:string, name:string },
    message:string,
    created:Date
}